module.exports = function(node) {
    var value = node.value;

    // remove escaped \n, i.e.
    // .a { content: "foo\
    // bar"}
    // ->
    // .a { content: "foobar" }
    value = value.replace(/\\\n/g, '');

    node.value = value;
};



//////////////////
// WEBPACK FOOTER
// ./~/csso/lib/compressor/compress/String.js
// module id = 2522
// module chunks = 0